export default class SearchButton extends HTMLElement {
  input = this.querySelector('input[type="checkbox"]');

  boundHandleChange = this.handleChange.bind(this);
  boundHandleSearchClosed = () => this.toggleInput(false);

  constructor() {
    super();

    if (!this.input) {
      throw new Error('SearchButton must have an input element with type="checkbox"');
    }
  }

  connectedCallback() {
    this.input.addEventListener('change', this.boundHandleChange);
    document.addEventListener('search:closed', this.boundHandleSearchClosed);
  }

  disconnectedCallback() {
    this.input.removeEventListener('change', this.boundHandleChange);
    document.removeEventListener('search:closed', this.boundHandleSearchClosed);
  }

  handleChange(e) {
    if (!(e.target instanceof HTMLInputElement)) return;

    if (e.target.checked) {
      document.dispatchEvent(new CustomEvent('search:open'));
    } else {
      document.dispatchEvent(new CustomEvent('search:close'));
    }
  }

  toggleInput(force) {
    this.input.checked = force !== undefined ? force : !this.input.checked;
  }
}
